export default __webpack_public_path__ + "static/media/background.b5f4fbb3.svg";